import { ColorInput } from "@/design-system/ColorInput";
import { Inline } from "@/design-system/Inline";
import { Input } from "@/design-system/Input";

interface Props {
  id?: string;
  value?: string;
  name?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  isError?: boolean;
  readOnly?: boolean;
}

export function ColorPicker({ value = "", onChange, onBlur, isError, ...props }: Props): React.ReactNode {
  return (
    <Inline gap="sm" wrap={false}>
      <div className="w-full">
        <Input
          id={props.id}
          name={props.name}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onBlur={onBlur}
          isError={isError}
          readOnly={props["readOnly"]}
        />
      </div>

      <ColorInput
        invalid={isError}
        name={props.name}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur}
        readOnly={props["readOnly"]}
      />
    </Inline>
  );
}
